function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M106.88 35.915c-.21-1.75-1.47-3.08-3.08-3.08H42.41c-1.82 0-3.36 1.54-3.36 3.36v35.35c0 1.75 1.54 3.36 3.22 3.36h6.58v9.66c0 1.05.63 2.03 1.61 2.38.35.14.7.21 1.05.21.7 0 1.33-.28 1.82-.77l.14-.14 7.63-11.41h42.63c1.68 0 3.15-1.54 3.15-3.36v-35.56zm-3.85 35.07H60.47c-.91 0-1.68.42-2.17 1.12l-5.6 8.33v-6.86c0-1.47-1.12-2.66-2.66-2.66h-7.07v-34.3h60.06v34.37z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M50.74 46.766h21.21c1.05 0 1.96-.84 1.96-1.96s-.84-1.96-1.96-1.96H50.74c-1.05 0-1.96.84-1.96 1.96s.91 1.96 1.96 1.96zm0 8.747h12.181c1.05 0 1.96-.84 1.96-1.96s-.84-1.959-1.96-1.959h-12.18c-1.05 0-1.96.84-1.96 1.96 0 1.119.91 1.959 1.96 1.959zm0 8.819h16.102c1.05 0 1.96-.84 1.96-1.96s-.84-1.96-1.96-1.96H50.74c-1.05 0-1.96.84-1.96 1.96s.91 1.96 1.96 1.96zm36.4-17.147c.91.49 2.1.14 2.59-.84a2.13 2.13 0 012.1-1.19c.98.14 1.75.91 1.89 1.89.07.91-.35 1.82-1.19 2.17-1.75.84-2.87 2.66-2.87 4.62v4.2c0 1.05.84 1.89 1.96 1.89s1.96-.84 1.96-1.89v-4.2c0-.49.28-.98.7-1.19 2.31-1.12 3.64-3.5 3.36-6.09-.28-2.73-2.45-4.9-5.25-5.32-2.59-.14-4.97 1.12-6.09 3.36-.49.98-.14 2.17.84 2.59zm4.482 15.397c-1.12 0-2.03.91-2.03 2.03 0 1.12.91 2.03 2.03 2.03 1.12 0 2.03-.91 2.03-2.03 0-1.12-.91-2.03-2.03-2.03z"
});

function SvgBenefit3Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 107 90"
  }, props), _ref, _ref2, _ref3);
}

export default SvgBenefit3Inline;